// ============================================
// SPAWN SYSTEM - 敵の出現管理
// ============================================

import { getP5 } from '../../core/p5-instance';
import { CONFIG } from '../../config/game-config';
import { ENEMY_CONFIG } from '../../config/enemy-config';
import {
    getWave,
    getEnemies,
    getBossDefeatPause, setBossDefeatPause,
    getBossWarning, setBossWarning,
    getBossWarningTimer, setBossWarningTimer,
    getLastBossWave, setLastBossWave,
    getSpawnTimer, setSpawnTimer
} from '../../store';
import { getDiffConfig } from '../../utils/helpers';
import { spawnEnemy } from '../../features/enemy/enemy';
import { spawnBoss } from '../../features/enemy/boss';

/**
 * updateSpawnLogic() - 敵の出現管理
 */
export function updateSpawnLogic(dt: number): void {
    const p = getP5();
    const bossDefeatPause = getBossDefeatPause();
    if (bossDefeatPause > 0) {
        setBossDefeatPause(bossDefeatPause - dt);
    }

    const enemies = getEnemies();
    const bossExists = enemies.some(e => e.isBoss);
    const wave = getWave();

    if (getBossDefeatPause() <= 0 && !bossExists) {
        let spawnTimer = getSpawnTimer();
        spawnTimer += dt;

        const diffCfg = getDiffConfig();
        const baseInterval = CONFIG.spawn.baseInterval * diffCfg.spawnIntervalMult;
        let spawnInterval = p.max(
            CONFIG.spawn.minInterval * diffCfg.spawnIntervalMult,
            baseInterval - wave * CONFIG.spawn.waveReduction
        );
        if (wave === 1) {
            spawnInterval *= 2;
        }

        if (spawnTimer >= spawnInterval) {
            spawnEnemy();
            setSpawnTimer(0);
        } else {
            setSpawnTimer(spawnTimer);
        }
    }

    // ボス出現
    const bossSpawnWave = ENEMY_CONFIG.boss.spawnWave as number;
    if (wave >= bossSpawnWave && wave % bossSpawnWave === 0 && getLastBossWave() !== wave) {
        if (!bossExists) {
            spawnBoss();
            setLastBossWave(wave);
        }
    }

    // ボス警告タイマー
    if (getBossWarning()) {
        let timer = getBossWarningTimer();
        timer -= dt;
        setBossWarningTimer(timer);
        if (timer <= 0) {
            setBossWarning(false);
        }
    }
}
